<template>
  <v-app-bar app color="background" elevation="0" class="pa-0">
    <VRow class="w-100 align-center mx-2 px-2 bg-surface text-on-surface" style="border-radius: 4px">
      <VCol class="pa-0">
        <div class="d-flex align-center ga-1">
          <VBtn icon color="on-surface" @click="$emit('toggle-drawer')">
            <VIcon>mdi-menu</VIcon>
          </VBtn>
          <AppBreadcrumbs />
        </div>
      </VCol>
      <VCol v-if="mobile" cols="auto" class="d-flex justify-end pa-0">
        <VMenu location="bottom left">
          <template #activator="{ props }">
            <VBtn variant="text" icon="mdi-dots-vertical" v-bind="props" color="data-table-action-button-color" />
          </template>
          <VList density="comfortable" class="data-table-action-button-list">
            <VListItem :title="$t('notifications')" class="w-100 d-flex items-center justify-space-between">
              <NavBarNotifications style="order: -1" />
            </VListItem>
            <VListItem
              :title="$t('toggleTheme')"
              :prepend-icon="isDark ? 'mdi-weather-sunny' : 'mdi-weather-night'"
              density="comfortable"
              @click="toggleTheme" />
          </VList>
        </VMenu>
      </VCol>
      <VCol v-else cols="auto" class="d-flex align-center justify-end ga-1 pa-0">
        <NavBarNotifications />
        <VBtn color="on-surface" icon @click="toggleTheme">
          <VIcon>{{ isDark ? 'mdi-weather-sunny' : 'mdi-weather-night' }}</VIcon>
        </VBtn>
        <UserProfile />
      </VCol>
    </VRow>
  </v-app-bar>
</template>

<script setup>
import { useDisplay } from 'vuetify';
import AppBreadcrumbs from './AppBreadcrumbs.vue';
import NavBarNotifications from './NavBarNotifications.vue';
import UserProfile from './UserProfile.vue';
import { useThemeConfig } from '@/composables/useThemeConfig';
import { useRoute, useRouter } from 'vue-router';

const { smAndDown: mobile } = useDisplay();

const route = useRoute();
const router = useRouter();

const { theme } = useThemeConfig();

// Theme toggle
const isDark = computed(() => theme.value === 'dark');

function toggleTheme() {
  theme.value = isDark.value ? 'light' : 'dark';
}
</script>
